module.exports = __webpack_public_path__ + "static/media/pn.3db9944f.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/pn.svg
// module id = 2190
// module chunks = 0